import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import { FIREBASE_CONFIG } from './data/env';

// The web config keys are NOT secret — they are public identifiers.
// Security is enforced by Firestore rules, not by hiding these values.
// Resolved at RUNTIME from the hostname (data/env.js) so one build serves
// prod and UAT; localhost falls back to `frontend/.env` (REACT_APP_*).
const firebaseConfig = FIREBASE_CONFIG;

if (!firebaseConfig.projectId) {
  // Don't crash the dev server before Firebase is wired up — just warn loudly.
  // eslint-disable-next-line no-console
  console.warn(
    '[firebaseConfig] Missing Firebase config. Copy frontend/.env.example to ' +
      'frontend/.env and fill in the REACT_APP_FIREBASE_* values.'
  );
}

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const auth = firebase.auth();
export const db = firebase.firestore();
export default firebase;
